import React from "react";

export default function Privacy() {
  return (
    <div style={{ padding: "1rem" }}>
      <h1>Privacy Policy</h1>
      <p>
        We respect your privacy. Any information you provide when submitting an
        order will be stored securely and only used for processing your
        purchase. By checking the consent box on the order form you agree to the
        collection and storage of your name, phone number and address for order
        handling purposes.
      </p>
      <p>
        We do not sell or share your data with third parties. For more detailed
        policy information please contact us.
      </p>
    </div>
  );
}
